import React, { useState } from "react";

const Enquiry = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [result, setResult] = useState("");

  const onSubmit = (e) => {
  e.preventDefault();

  const form = e.target;

  const name = form.name.value;
  const email = form.email.value;
  const phone = form.phone.value;
  const days = form.days.value;
  const pickUp = form.pick_up_point.value;
  const drop = form.drop_location.value;
  const cab = form.bus.value;
  const date = form.date.value;
  const message = form.message.value;

  const whatsappMessage = `Hello Prince Cabs,%0A%0AI would like to make an enquiry with the following details:%0A%0A👤 Name: Dexter%0A📧 Email: admin@gmail.com%0A📞 Phone: 7566140512%0A📅 Journey Date: 2025-09-19%0A🕒 Number of Days: 2%0A📍 Pickup Point: pune%0A📍 Drop Location: mumbai%0A🚗 Cab Selected: Ertiga (6+1 Seater)%0A📝 Message: Testing%0A%0APlease get back to me with availability and pricing.%0AThank you!`;


  // Redirect to WhatsApp
  const phoneNumber = "919284304420"; // No + or spaces
  const whatsappURL = `https://wa.me/${phoneNumber}?text=${whatsappMessage}`;

  window.open(whatsappURL, "_blank");

  setFormSubmitted(true);
  setResult("");
};


  return (
    <>


     <section className="inner-banner-wrap">
        <div
          className="inner-baner-container"
          style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
        >
          <div className="container">
            <div className="inner-banner-content">
              <h1 className="inner-title">Enquiry</h1>
            </div>
          </div>
        </div>
        <div className="inner-shape"></div>
      </section>


    
      <section className="contact-area section-padding">
        <div className="container">
          <div className="row mt-70">
            <div className="col-lg-12 col-12 align-self-center wow fadeInUp">
              <div className="contact-form">
                <div className="section-heading">
                  <span>Get In Touch</span>
                  <h2>Send us a Message</h2>
                </div>

                {!formSubmitted ? (
                  <form onSubmit={onSubmit} className="contact-form">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="name">Your Full Name</label>
                        <input
                          type="text"
                          name="name"
                          id="name"
                          placeholder="Your Full Name"
                          required
                          pattern="[A-Za-z\s]+"
                          title="Name must contain only letters"
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="email">Your Email</label>
                        <input
                          type="email"
                          name="email"
                          id="email"
                          placeholder="Your Email"
                          required
                          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="phone">Your Phone</label>
                        <input
                          type="tel"
                          name="phone"
                          id="phone"
                          placeholder="Your Phone"
                          required
                          pattern="[6-9]{1}[0-9]{9}"
                          title="Enter valid 10-digit Indian mobile number"
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="days">Number of Days</label>
                        <input
                          type="number"
                          name="days"
                          id="days"
                          placeholder="Number of Days"
                          required
                          min="1"
                          max="100"
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="pick_up_point">Pick Up Point</label>
                        <input
                          type="text"
                          name="pick_up_point"
                          id="pick_up_point"
                          placeholder="Pick Up Point"
                          required
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="drop_location">Drop Location</label>
                        <input
                          type="text"
                          name="drop_location"
                          id="drop_location"
                          placeholder="Drop Location"
                          required
                        />
                      </div>
                      <div className="col-md-12 mb-3">
                        <label htmlFor="bus">Select Cabs</label>
                        <select name="bus" id="bus" required>
                          <option value="" disabled selected>Select Cabs</option>
                          <option value="Swift Dzire (4 + 1 Seater)">Swift Dzire (4 + 1 Seater)</option>
                          <option value="Kia Carens(6 + 1 Seater)">Kia Carens (6 + 1 Seater)</option>
                          <option value="Ertiga (6 + 1 Seater)">Ertiga (6 + 1 Seater)</option>
                          <option value="Innova (6 + 1 Seater)">Innova (6 + 1 Seater)</option>
                          <option value="Innova Crysta (6 + 1 Seater)">Innova Crysta (6 + 1 Seater)</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      <div className="col-md-12 mb-3">
                        <label htmlFor="date">Date of Journey</label>
                        <input
                          type="date"
                          name="date"
                          id="date"
                          min={new Date().toISOString().split("T")[0]}
                          required
                        />
                      </div>
                      <div className="col-12 mb-3">
                        <label htmlFor="message">Your Message</label>
                        <textarea
                          name="message"
                          id="message"
                          rows="6"
                          placeholder="Your Message"
                        ></textarea>
                      </div>
                      <div className="col-12 text-center">
                        <button type="submit" className="yellow_btn">
                          <span>Send Message</span>
                        </button>
                      </div>
                      {result && (
                        <div className="col-12 text-center mt-3">{result}</div>
                      )}
                    </div>
                  </form>
                ) : (
                  <div className="alert alert-success text-center p-5 my-5">
                    <h3>🎉 Thank you!</h3>
                    <p>Your enquiry has been submitted successfully. We will contact you soon.</p>
                    <button onClick={() => {
                      setFormSubmitted(false);
                      setResult("");
                    }} className="yellow_btn mt-3">
                      Send Another Enquiry
                    </button>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Enquiry;
